const PublicLogo = () => {
  return (
    <a href="https://cowbell.insure" target="_blank" rel="noreferrer">
      <img
        className="public-logo"
        src="logos/CowbellLogo.svg"
        alt="Cowbell Cyber"
      />
    </a>
  );
};

export default PublicLogo;
